import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import type {HideLabelsStrategyData} from '../../types/hide-labels-strategy-data.type';
import {HideLabelsStrategyService} from '../../HideLabelsStrategyService';

@Service({id: 'hideLabelsFallbackStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<HideLabelsStrategyService> {

  build(details: HideLabelsStrategyData): HideLabelsStrategyService {
      return new HideLabelsStrategyFallback(details);
  }
}

export class HideLabelsStrategyFallback extends HideLabelsStrategyService {
  details;

  constructor(details: HideLabelsStrategyData) {
      super();
      this.details = details;
  }

  isHideLabels():boolean {
      return false;
  }
}
